import styles from "./styles.module.scss";

export const WidgetSkeleton = () => (
  <div className={styles.widgetSkeleton}>
    <div className={styles.widgetHeader}>
      <div className={styles.titleSkeleton} />
      <div className={styles.iconSkeleton} />
    </div>
    <div className={styles.percentSkeleton} />
  </div>
);

export const GroupSkeleton = ({
  count = 4,
  withHeader = false,
}: {
  count?: number;
  withHeader?: boolean;
}) => (
  <div className={styles.groupSkeleton}>
    {withHeader && (
      <div className={styles.groupHeaderSkeleton}>
        <div className={styles.groupTitleSkeleton} />
        <div className={styles.groupIconSkeleton} />
      </div>
    )}
    <div className={styles.widgetsContainer}>
      {Array(count)
        .fill(0)
        .map((_, idx) => (
          <div key={idx} className={styles.widgetWrapper}>
            <WidgetSkeleton />
          </div>
        ))}
    </div>
  </div>
);
